import { Dispatch } from '@lumapps/redux/types';

import { normalisePageId } from '../utils/normalisePageId';
import { actions } from './slice';

export const setCurrentPage = (id: string, onPageChanged?: (pageId: string) => void) => (dispatch: Dispatch) => {
    const pageId = normalisePageId(id);
    dispatch(actions.setCurrentPage(pageId));
    onPageChanged?.(pageId);
};
